import { render, staticRenderFns } from "./AccountBulkUpdate.vue?vue&type=template&id=98d513b0&"
import script from "./AccountBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountBulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AccountBulkUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports